<template>
    <v-dialog v-model="show" dark>
        <v-card v-if="needConfirm">
            <v-card-title class="blinky-text headline">Confirm Malware Action</v-card-title>
            <v-card-text>
                <p>
                    Giving someone malware or removing malware from someone can
                    trigger the anti-malware software which will alert IT staff.
                </p>
                <p>
                    Do you still wish to proceed?
                </p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="needConfirm = false">Cancel</v-btn>
                <v-btn v-if="countdown > 0" text color="red" disabled>Yes ({{ countdown }})</v-btn>
                <v-btn v-else text color="red" @click="doConfirm()">Yes</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-else>
            <v-card-title class="headline">Malware</v-card-title>
            <v-tabs v-model="tab" background-color="transparent" grow>
                <v-tab>Keyloggers</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card dark tile>
                        <v-card-text>
                            <p>
                                The keylogger malware can be used to intercept what a target might
                                be writing. This particular keylogger malware intercepts messages
                                that are sent and received by a target.
                            </p>
                        </v-card-text>
                        <v-card-text>
                            <h3>Deployed Keyloggers</h3>
                            <p>
                                These are the different keyloggers that you have deployed to people.
                            </p>
                            <ul>
                                <li v-for="player in players" :key="player.id">
                                    {{ player.name }}
                                    <span v-if="!deployedKeyloggers.includes(player.id)">
                                        (not infected)
                                        <a @click="hackPlayer(player.id, 'keylogger')">[deploy]</a>
                                    </span>
                                    <span class="red--text" v-else>
                                        (infected)
                                        <a @click="unhackPlayer(player.id, 'keylogger')">[undeploy]</a>
                                    </span>
                                </li>
                            </ul>
                        </v-card-text>
                        <v-card-text>
                            <h3>{{ shownMessages.length }} Intercepted Messages</h3>
                            <p>
                                <b>Note:</b> You will need to press the 'check for messages' button below to check your deployed keyloggers for intercepted messages.
                            </p>
                            <p>
                                The messages displayed below have been intercepted by one of your deployed keyloggers.
                                The <span class="message-people">yellow</span> text is who the sender and recipient of the message respectively.
                                The <span class="message-type">magenta</span> text is the type of message which will be one of text, email or social.
                                The <span class="message-subject">cyan</span> text might be shown for some messages and is the subject of the message.
                                The <span class="message-text">lime</span> text is the content of the message.
                                The <span class="message-meta">red</span> text is the date and time that the message was sent and the day that it was sent on in game.
                                Removing all messages will clear them from this screen and you will not be able to view them again.
                            </p>
                            <p>
                                <a @click="showAllMessages()">[show all]</a>&emsp;
                                <a @click="hideAllMessages()">[hide all]</a>&emsp;
                                <a @click="doAction('refresh')">[check for messages]</a>
                            </p>
                            <ul class="message-list">
                                <li v-for="message in shownMessages" :key="message.id">
                                    <span class="message-people">{{ message.sender.name }} &#8594; {{ message.recipient ? message.recipient.name : "ALL" }}</span>
                                    <span class="message-type"> [{{ message.type }}]</span>
                                    <span class="message-subject"> {{ message.subject }}</span>:
                                    <span class="message-text">"{{ message.content }}"</span>
                                    <span class="message-meta"> @ {{ message.sent }} (Day {{ message.gameDay }})</span>
                                    &emsp;<a @click="hideMessage(message.id)">[hide]</a>
                                </li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
            <v-card-actions>
                <v-spacer/>
                <v-btn text @click.stop="show = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        value: Boolean,
        action: Object
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        },
        shownMessages() {
            if (!this.hackerInfo.interceptMessages) { return []; }
            return this.hackerInfo.interceptMessages.filter(m => !this.hiddenMessages.includes(m.id))
        },
        ...mapState({
            hackerInfo: state => state.hackerInfo,
            players: state => state.players,
            deployedKeyloggers(state) {
                return state.hackerInfo.infectedPlayers.keylogger || [];
            },
            hiddenMessages: state => state.hiddenMessageIds
        })
    },
    data: () => ({
        tab: 0,
        needConfirm: false,
        confirmAction: null,
        confirmPayload: null,
        countdown: 5
    }),
    methods: {
        doConfirm() {
            this.doAction(this.confirmAction, this.confirmPayload || {});
            this.needConfirm = false;
            this.countdown = 5;
        },
        hackPlayer(player, type) {
            this.confirmAction = "hack";
            this.confirmPayload = {
                player: player,
                type: type
            }
            this.needConfirm = true;
        },
        unhackPlayer(player, type) {
            this.confirmAction = "unhack";
            this.confirmPayload = {
                player: player,
                type: type
            }
            this.needConfirm = true;
        },
        doAction(type, payload = {}) {
            this.$socket.client.emit("hacker_action", {
                action: type,
                ...payload
            })
        },
        hideMessage(id) {
            if (!this.hiddenMessages.includes(id)) {
                this.$store.commit("HIDE_MESSAGE", id);
            }
        },
        showAllMessages() {
            this.$store.commit("SHOW_ALL_MESSAGES");
        },
        hideAllMessages() {
            this.shownMessages.forEach(msg => {
                this.hideMessage(msg.id);
            });
        }
    },
    mounted() {
        setInterval(() => {
            if (this.show && this.needConfirm && this.countdown > 0) {
                this.countdown--;
            }
        }, 1000);
    }
}
</script>

<style scoped>
    ul.message-list {
        list-style-type: none;
        padding-left: 0;
        font-size: 0.9em;
    }

    ul.message-list > li:nth-of-type(odd) {
        background-color: #0e0e0e;
    }

    .message-people {
        color: yellow;
    }

    .message-type {
        color: magenta;
    }

    .message-subject {
        color: cyan;
    }

    .message-text {
        color: lime;
        font-size: 1.2em;
        font-weight: 700;
    }

    .message-meta {
        color: red;
    }

    @keyframes blink {
        0%, 100% {
            color: #e53935;
        }
        50% {
            color: #fff;
        }
    }

    .blinky-text {
        animation: blink 0.8s infinite;
        -o-animation: blink 0.8s infinite;
        -moz-animation: blink 0.8s infinite;
        -webkit-animation: blink 0.8s infinite;
    }
</style>

<style scoped>
    * {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
    }
</style>
